import React, { useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import * as Icon from "react-bootstrap-icons";

import configData from "../config.json";

const Atten = () => {
  const [attenData, setAttenData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);

  const [inputData, setInputData] = useState({
    empCode: "",
    dateFrom: "",
    dateTo: "",
  });

  // Handle Input
  const handleInput = (e) => {
    const { name, value } = e.target;

    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !inputData.empCode ||
      !inputData.dateFrom ||
      !inputData.dateTo
    ) {
      alert("Please fill all fields.");
      return;
    }

    if (inputData.dateFrom > inputData.dateTo) {
      alert("Invalid Date Range");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${configData.SERVER_URL}/attenByCode`,
        inputData
      );

      setAttenData(res.data);

      if (res.data.length === 0) {
        setNoResults(true);
      } else {
        setNoResults(false);
      }
    } catch (error) {
      console.error("Search Error:", error);
      alert("Failed to load attendance data.");
    } finally {
      setLoading(false);
    }
  };

  const printDiv = async(printDiv) => {
        const printElement = document.getElementById(printDiv);
        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                     ${printElement.innerHTML}
                </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
        
    };

  return (
    <>
      <div className="container py-4">
        <div className="card card-body bg-info text-center shadow border-0 mb-4">
        <h3>Bangladesh Steel and Engineering Corporation</h3>
        <h6>102, Kazi Nazrul Islam Avenue, Dhaka-1215</h6>
        </div>
        {/* Header */}
        <div className="card shadow border-0 mb-4">
          <div className="card-header text-white" style={{ background: "linear-gradient(90deg,#0d6efd,#0dcaf0)"}} >
            <h5 className="mb-0">
              <Icon.PersonBadgeFill className="me-2" />
              Personal Attendance Report
            </h5>
          </div>

          {/* Search Section */}
          <div className="card-body bg-light">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">

                {/* Staff Code */}
                <div className="col-lg-3 col-md-6">
                  <label className="form-label fw-bold">Staff Code</label>
                  <input type="search" className="form-control" name="empCode" value={inputData.empCode} onChange={handleInput} placeholder="Enter Staff Code"/>
                </div>

                {/* Date From */}
                <div className="col-lg-3 col-md-6">
                  <label className="form-label fw-bold">Date From</label>
                  <input type="date" className="form-control" name="dateFrom" value={inputData.dateFrom} onChange={handleInput}/>
                </div>

                {/* Date To */}
                <div className="col-lg-3 col-md-6">
                  <label className="form-label fw-bold">Date To</label>
                  <input type="date" className="form-control" name="dateTo" value={inputData.dateTo} onChange={handleInput} />
                </div>

                {/* Button */}
                <div className="col-lg-3 col-md-6 d-flex align-items-end">
                  <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" ></span>
                        Loading...
                      </>
                    ) : (
                      <>
                        <Icon.Search className="me-2" />
                        Search
                      </>
                    )}
                  </button>
                </div>
                <div className="col-lg-3 col-md-6 d-flex align-items-end">
                  <button type="button" className="btn btn-warning"
                      onClick={() => printDiv("printDiv")}>
                      <Icon.Printer />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Attendance Table */}
        <div className="card shadow border-0" id="printDiv">

          <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
              <Icon.Table className="me-2" />
              Attendance Details   
              </h5>
              {attenData.length > 0 && (
                <small>
                  (date from {inputData.dateFrom? format(new Date(inputData.dateFrom), "dd-MM-yyyy"): ""} to {inputData.dateTo? format(new Date(inputData.dateTo), "dd-MM-yyyy"): ""} )
                </small>
              )}

            {attenData.length > 0 && (
              <span className="badge bg-light text-dark ">{attenData[0]?.empName}({attenData[0]?.empCode})</span>
            )}
          </div>

          <div className="card-body table-responsive">

            {/* No Result */}
            {noResults && (
              <div className="alert alert-warning text-center">
                <Icon.ExclamationTriangle className="me-2" />
                No attendance data found.
              </div>
            )}

            {/* Table */}
            {attenData.length > 0 && (
              <table className="table table-bordered table-hover align-middle">

                <thead className="table-dark text-center">
                  <tr>
                    <th>Date</th>
                    <th>In Time</th>
                    <th>Out Time</th>
                    <th>Remarks</th>
                    <th>Description</th>
                  </tr>
                </thead>

                <tbody>
                  {attenData.map((data, index) => (
                    <tr key={index}>
                      <td>
                        {format(new Date(data.eventDate),"dd-MM-yyyy")}
                      </td>

                      <td>{data.entryTime || "-"}</td>

                      <td>{data.exitTime || "-"}</td>

                      <td>
                        <span className="badge bg-info text-dark">{data.remarks || "-"}</span>
                      </td>

                      <td>{data.description || "-"}</td>
                    </tr>
                  ))}
                </tbody>

              </table>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default Atten;